import i18n from 'i18next'
import React, { ReactElement } from 'react'
import Card from 'ui/atoms/Card/Card'
import { registerDefaultProps, registerUiConfigComponent } from 'ui/uiConfig/factory'
import type { AbSLabsProps } from './AbSLabs.types'

const defaultProps: Omit<AbSLabsProps, `datasets` | `children`> = {}
registerUiConfigComponent(`abs_labs`, AbSLabs, {
  isSingletonComponent: true,
  title: i18n.t(`AbS Labs`),
})
registerDefaultProps(`abs_labs`, defaultProps)

export default function AbSLabs({ children }: AbSLabsProps): ReactElement {
  return (
    <>
      {children.map((child, index) => (
        <Card key={`abs_labs_${index}`}>{child}</Card>
      ))}
    </>
  )
}
